import { Pipe, PipeTransform } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';

@Pipe({ name: 'showMonth' })
export class ShowMonthPipe implements PipeTransform {
    constructor(private utilitiesService: UtilitiesService) {}

    public transform(value: string, args?: any): any {
        if (value) {
            return this.utilitiesService.calculateMonth(value, 'date');
        }
    }

}
